export default __webpack_public_path__ + "locales/bg/WebPlugins.json?hash=1a4b38a437955508713fd4c868daf355";